import { Navigate, useSearchParams } from "react-router-dom";
import { UseCaseWizardLoader } from "../../layouts/skeleton-loaders/UseCaseWizardLoader";
import { UseCaseWizard } from "../../organisms/registry/UseCaseWizard";

export default function DefaultWizard() {
  const [searchParams] = useSearchParams();
  const questionnaire = searchParams.get("id");

  if (!questionnaire) {
    return <Navigate to="/organization/overview" />;
  }

  return questionnaire ? <UseCaseWizard templateId={questionnaire} /> : <UseCaseWizardLoader />;
}
